import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import VueRouter from "vue-router";
import { BootstrapVue, IconsPlugin, BVToastPlugin, VBToggle } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { ValidationProvider, extend } from "vee-validate";
import { required, min_value, max_value, length,max } from 'vee-validate/dist/rules';
import store from "./_configuration/store/index";
import "@fortawesome/fontawesome-free/css/all.min.css";
import axios from "axios";
import { router } from "./_configuration/routes.module"
import VueHtmlToPaper from 'vue-html-to-paper';
import toastr from './mixins/toastr';
import VueLodash from 'vue-lodash'
import lodash from 'lodash'


import { htmlToPaperConfig } from "./_configuration/plugins/VueHtmlToPaper.module"
Vue.use(VueRouter);
Vue.config.productionTip = false;

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(BVToastPlugin);
Vue.use(VBToggle);

Vue.component("v-select", vSelect);
Vue.component("ValidationProvider", ValidationProvider);
Vue.use(require("vue-moment"));
Vue.use(Vuex);
Vue.use(VueHtmlToPaper, htmlToPaperConfig);
Vue.mixin(toastr)
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

extend('required', {
  ...required,
  message: 'To pole jest wymagane'
});

extend('min_value', {
  ...min_value,
  message: "Wartość musi być większa od {min}"
});
extend('max_value', {
  ...max_value,
  message: "Wartość musi być mniejsza od {max}"
});
extend('length', {
  ...length,
  message: "Wartość musi posiadać {length} znaków"
});
extend('max', {
    ...max,
    message: "Tekst może posiadać maksymalnie {length} znaki / znaków"
});


axios.interceptors.request.use(
  function (config) {
    var token = store.state.token;
    var authHeader = token != undefined
      ? `Bearer ${token}`
      : "";

    // Ensure headers object exists
    config.headers = config.headers || {};

    if (authHeader) {
      config.headers["Authorization"] = authHeader;
    }

    // Set CORS header directly on headers object
    config.headers['Access-Control-Allow-Origin'] = '*';
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
